import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

import Page from '../../Page';
import GrowthCreditsStats from './GrowthCreditsStats';

function GrowthCreditsPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Page
      actions={<Button type={'primary'}>{t('Redeem Credits')}</Button>}
      collapseHeader={false}
      description={t(
        'Manage and redeem growth credits to cover marketing costs that help you reach even more donors.',
      )}
      title={t('Growth Credits')}
    >
      <GrowthCreditsStats />
    </Page>
  );
}

export default GrowthCreditsPage;
